import installLocaleShortcut from '../libs/localeShortcut';

installLocaleShortcut();
